// BigNumber.js — labelled number stepper; the roomy replacement for the
// cramped numeric infrastructure inputs (users, workstations, servers).
// Controlled: pass `value` + `onChange(n)`. Same state as the field it
// replaces — just a bigger control. Faithful port of components/core/BigNumber.jsx,
// extended with the shared-shell contract props (max, step, suffix).
import React from 'react';
import { v3 } from '../../lib/styleTokens';

export function BigNumber({
  label,
  value,
  onChange,
  min = 0,
  max = Infinity,
  step = 1,
  suffix,
  delta,
  deltaColor,
  hint,
}) {
  const set = (next) => {
    if (typeof onChange === 'function' && next >= min && next <= max) onChange(next);
  };
  const stepBtn = {
    width: 36,
    border: 'none',
    background: 'transparent',
    color: v3.color.muted,
    fontSize: 18,
    cursor: 'pointer',
  };
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 8 }}>
        <span
          style={{
            fontFamily: v3.font.family,
            fontSize: v3.font.size.small,
            color: v3.color.muted,
            fontWeight: v3.font.weight.medium,
            textTransform: 'uppercase',
            letterSpacing: '0.3px',
          }}
        >
          {label}
        </span>
        {delta && (
          <span
            style={{
              fontFamily: v3.font.mono,
              fontSize: v3.font.size.micro,
              fontWeight: v3.font.weight.semibold,
              color: deltaColor || v3.color.muted,
            }}
          >
            {delta}
          </span>
        )}
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'stretch',
          border: `1px solid ${v3.color.border}`,
          borderRadius: v3.radius.card,
          background: v3.color.card,
          overflow: 'hidden',
          height: 50,
        }}
      >
        <button onClick={() => set(value - step)} aria-label={`Decrease ${label}`} style={stepBtn}>
          {'−'}
        </button>
        <div
          style={{
            flex: 1,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            fontFamily: v3.font.mono,
            fontSize: 22,
            fontWeight: v3.font.weight.semibold,
            color: v3.color.body,
            borderLeft: `1px solid ${v3.color.borderSoft}`,
            borderRight: `1px solid ${v3.color.borderSoft}`,
            letterSpacing: '-0.4px',
          }}
        >
          {value}
          {suffix && (
            <span style={{ fontFamily: v3.font.family, fontSize: v3.font.size.small, color: v3.color.muted }}>
              {suffix}
            </span>
          )}
        </div>
        <button onClick={() => set(value + step)} aria-label={`Increase ${label}`} style={stepBtn}>
          +
        </button>
      </div>
      {hint && (
        <div style={{ fontFamily: v3.font.family, fontSize: v3.font.size.micro, color: v3.color.mutedSoft, marginTop: 6 }}>
          {hint}
        </div>
      )}
    </div>
  );
}
